import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  TextInput,
  Alert,
} from "flowbite-react";
import { useEffect, useState } from "react";
import { SquareX } from "lucide-react";
import axiosInstance from "../config/config";

export function ModalFrom({ closeModal, e_id, fetchItems }) {
  const [item_name, setItemName] = useState("");
  const [note, setNote] = useState("");
  const [t_color, setTColor] = useState("failure");
  const [msg, setMsg] = useState("");
  const [adis, setAdis] = useState(false);
  const [msg_n, setMsg_n] = useState("");

  useEffect(() => {
    if (e_id) {
      const fetchItem = async () => {
        try {
          const response = await axiosInstance.post("", {
            SysID: `select * from dbo.job_item where id=${e_id};`,
          });
          setItemName(response.data[0].item_name);
          setNote(response.data[0].note || "");
        } catch (error) {
          console.error("Error fetching item:", error);
        }
      };
      fetchItem();
    }
  }, [e_id]);

  const showAlert = (color, title, message) => {
    setTColor(color);
    setMsg_n(title);
    setMsg(message);
    setAdis(true);
    setTimeout(() => setAdis(false), 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!item_name.trim()) {
      showAlert("failure", "Error!", "Item name is required!");
      return;
    }
    try {
      if (e_id) {
        await axiosInstance.post("", {
          SysID: `EXEC dbo.up_job_item @id=${e_id}, @item_name='${item_name}', @note='${note}'; SELECT 1`,
        });
        showAlert("green", "Success!", "Item updated.");
      } else {
        await axiosInstance.post("", {
          SysID: `EXEC dbo.add_job_item @item_name='${item_name}', @note='${note}'; SELECT 1`,
        });
        showAlert("green", "Success!", "Item saved.");
        setItemName("");
        setNote("");
      }
      fetchItems();
    } catch (error) {
      console.error("Error saving item:", error);
      showAlert("failure", "Error!", "Failed to save.");
    }
  };

  return (
    <Modal show={true} size="md" onClose={closeModal} popup>
      <ModalHeader />
      <ModalBody>
        <div className="space-y-6">
          <div className="flex">
            <h3 className="text-xl font-medium text-gray-900 dark:text-white">
              {e_id ? "Edit Item" : "Add Item"}
            </h3>
            <SquareX
              onClick={closeModal}
              className="ml-auto text-red-600 hover:cursor-pointer"
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="item_name">Item Name</Label>
            </div>
            <TextInput
              id="item_name"
              value={item_name}
              onChange={(e) => setItemName(e.target.value)}
              placeholder="e.g. TV, Tab, WiFi Router"
              required
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="note">Note</Label>
            </div>
            <TextInput
              id="note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Optional note"
            />
          </div>
          <div className="w-full flex px-8">
            <Button onClick={() => { setItemName(""); setNote(""); }}>
              Clear
            </Button>
            <Button onClick={handleSubmit} className="ml-auto">
              {e_id ? "Update" : "Add"}
            </Button>
          </div>
        </div>
      </ModalBody>
      {adis && (
        <Alert className="absolute right-0 top-12" color={t_color}>
          <span className="font-medium">{msg_n}</span> {msg}
        </Alert>
      )}
    </Modal>
  );
}
